import React, { useState } from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

const FAQ = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
const faqs = [
  {
    question: 'What is SumahiQR and how does it work?',
    answer:
      'SumahiQR is a smart solution that helps businesses get more Google reviews by allowing customers to tap or scan a card using NFC or QR technology. It’s seamless, fast, and doesn’t require any app installation.',
  },
  {
    question: 'Do I need technical skills to use SumahiQR?',
    answer:
      'Not at all. SumahiQR is plug-and-play. Simply place the card on your counter or hand it to customers — they just tap or scan, and they’re taken directly to your Google Review page.',
  },
  {
    question: 'How can SumahiQR help improve my business rating?',
    answer:
      'The more positive reviews you get, the better your business appears in search rankings. SumahiQR increases the chances of real-time feedback from satisfied customers, boosting your reputation.',
  },
  {
    question: 'Is SumahiQR suitable for all industries?',
    answer:
      'Yes! Whether you run a salon, café, clinic, retail shop, or even a freelance service — SumahiQR is built to adapt to any industry where customer feedback matters.',
  },
  {
    question: 'Can I customize the SumahiQR card with my branding?',
    answer:
      'Absolutely. We offer personalized cards with your logo and brand colors so it feels like an extension of your identity while keeping things professional.',
  },
  {
    question: 'What makes SumahiQR better than  review requests?',
    answer:
      'Traditional review links can be forgotten or ignored. SumahiQR makes it instant and interactive — right at the point of service, when the customer is most satisfied.',
  },
];


	const [openIndex, setOpenIndex] = useState(null);

	const toggleFaq = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<>
			<div
				style={{
					 fontFamily: 'Inter, serif',
					paddingLeft: matches ? 40 : 80,
					paddingRight: matches ? 40 : 80,
					paddingTop: 50,
					paddingBottom: 50,
				}}>
				<div className='faq-container'>
					<h1>Frequently Asked Questions</h1>
					<p className='subtitle'>Got a Question? We are here to Answer!!</p>
				</div>

				<Grid container spacing={2}>
					{faqs.map((faq, index) => (
						<Grid item xs={12} lg={6}>
							<div key={index} className='faq-item'>
								<div className='faq-question' onClick={() => toggleFaq(index)}>
									<span
										className='faq-item-title'
										style={{ fontSize: matches ? 14 : 16 }}>
										{faq.question}
									</span>
									<span
										className={`faq-item-icon ${
											openIndex === index ? 'rotate' : ''
										}`}>
										+
									</span>
								</div>
								<div
									className={`faq-content ${
										openIndex === index ? 'visible' : ''
									}`}>
									<p>{faq.answer}</p>
								</div>
							</div>
						</Grid>
					))}
				</Grid>
			</div>
		</>
	);
};

export default FAQ;
